import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
const END_POINT = process.env.REACT_APP_BASE_URL_AUTH;

const LoginAdmin = () => {
    return ({
        type: types.LOGIN_ADMIN
    })
}

const LogoutAdmin = () => {
    return ({
        type: types.LOGOUT_ADMIN,
    })
}


const sendNotify = () => {
    return ({
        type: types.SEND_NOTIFICATIONS
    })
}


export const AuthLogin = (email, password, navigate,setloadBtn) => {
    return function (dispatch) {
        setloadBtn(true)
        axios.post(`${END_POINT}/api/auth/login?email=${email}&password=${password}`,).then((res) => {
            console.log(res);
            if (res.data.status == "Success") {
                localStorage.setItem("tokenA", res.headers.authorization)
                console.log(res.data.data.role)
                localStorage.setItem("roleA", res.data.data.role)
                dispatch(LoginAdmin());
                setloadBtn(false)
                navigate('/')
                window.location.reload();
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
            setloadBtn(false)
        })
    }
}

export const AuthLogout = (navigate) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        console.log(token);
        axios.post(`${END_POINT}/api/auth/logout`,{}, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.status == "Success") {
                dispatch(LogoutAdmin());
                localStorage.removeItem('tokenA');
                localStorage.removeItem('XX')
                navigate('/')
                window.location.reload();
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
        })
    }
}

export const SendNotificationn = (title,body,setloadBtn) => {
    return function (dispatch) {
        setloadBtn(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${END_POINT}/api/notification-send`,{
            title,body
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(sendNotify());
                notifysuccess(res.data.message)
                setloadBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
            setloadBtn(false)
        })
    }
}

export const changeUserId = (id) => {
    return ({
        type: types.SET_USER_ID,
        payload: id
    })
}